// extracted by mini-css-extract-plugin
export default {"products":"Qt-z","card":"Rt-z","oosMessaging":"St-z"};